module.exports = __webpack_public_path__ + "img/end.2d6ed718.svg";